// Import model
import { CustomerCondition } from '../models/CustomerCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CustomerIndexedFields } from '../models/CustomerIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CustomerIndexedFieldsSerializer } from './CustomerIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CustomerCondition - handles JSON serialization and deserialization with type validation
 */
export class CustomerConditionSerializer {
  /**
   * Deserializes a JSON string into a CustomerCondition instance
   */
  static deserialize(json: string): CustomerCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CustomerCondition instance
   */
  static fromObject(obj: any): CustomerCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CustomerCondition');
    }


    const instance: CustomerCondition = {
      fieldName: obj['fieldName'] as CustomerIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CustomerCondition instances
   */
  static deserializeArray(json: string): CustomerCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CustomerCondition instance to a JSON string
   */
  static serialize(instance: CustomerCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CustomerCondition instance to a plain object
   */
  static toObject(instance: CustomerCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CustomerCondition instances to a JSON string
   */
  static serializeArray(instances: CustomerCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
